var map = {
	"./banner1.png": 756,
	"./banner2.png": 9467,
	"./banner3.png": 7640,
	"./banner4.png": 4378,
	"./banner5.jpg": 1660,
	"./banner6.jpg": 6306,
	"./cooperate/douyin.jpg": 8782,
	"./cooperate/gaode.jpg": 4312,
	"./homemp4.jpg": 6208,
	"./icon1-h.png": 2744,
	"./icon1.png": 6271,
	"./icon2-h.png": 5556,
	"./icon2.png": 5743,
	"./icon3-h.png": 9862,
	"./icon3.png": 2161,
	"./icon4-h.png": 4247,
	"./icon4.png": 2207,
	"./icon5-h.png": 9765,
	"./icon5.png": 6212,
	"./icon6-h.png": 5913,
	"./icon6.png": 4081,
	"./service_city.png": 1917,
	"./service_daily.png": 8277,
	"./service_knight.jpg": 5988,
	"./service_knight.png": 4243,
	"./service_merchant.png": 7161,
	"./service_person.jpg": 8371
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9229;